var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page"
  }, [_c('div', {
    staticClass: "result"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": require("./images/result-bg.jpg")
    }
  }), _c('div', {
    staticClass: "result__info"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'LiffProjAbbottAnd2026LotteryQ2EarnCount',
        query: {
          event_code: 'e2026Q2'
        }
      }
    }
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": require("./images/result-btn.png")
    }
  })])], 1)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }